// extracted by mini-css-extract-plugin
export default {"GetTheApp":"GetTheApp_GetTheApp__XkPcW","Legal":"GetTheApp_Legal__DbRox","TermsOfUse":"GetTheApp_TermsOfUse__bJZNn"};